import { Outlet } from "react-router-dom";
import AdminLayout from "./AdminLayout";

function AdminHomePage() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

export default AdminHomePage;
